import { MediaStoryCard } from '@components/display/cards';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid2, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useGetOverviewBlogItemsQuery } from '@overview/services';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const ITEMS_PER_PAGE_MD = 4;
const ITEMS_PER_PAGE_SM = 3;

export const OverviewBlog = () => {
    const theme = useTheme();
    const intl = useIntl();

    const isMdOrAbove = useMediaQuery(theme.breakpoints.up('md'));
    const { data: latestBlogItems, isLoading: isOverviewBlogLoading } = useGetOverviewBlogItemsQuery(
        {
            per_page: isMdOrAbove ? ITEMS_PER_PAGE_MD : ITEMS_PER_PAGE_SM,
            page: 1,
        },
        {
            selectFromResult: ({ data, ...rest }) => ({
                ...rest,
                data: data?.slice(0, isMdOrAbove ? ITEMS_PER_PAGE_MD : ITEMS_PER_PAGE_SM) || [],
            }),
        }
    );

    return !!latestBlogItems?.length || isOverviewBlogLoading ? (
        <Box px={{ xs: '20px', md: '65px' }} py="25px">
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb="26px">
                <Typography fontFamily="museo-sans" fontSize={32} fontWeight={600} letterSpacing={-1}>
                    <FormattedMessage id="blog.latest" defaultMessage="Latest Blog Posts" />
                </Typography>
                <Button
                    component={Link}
                    to="blog"
                    variant="text"
                    endIcon={<ArrowForwardIcon />}
                    className="min-w-fit font-medium"
                >
                    <FormattedMessage id="common.actions.showAll" defaultMessage="Show all" />
                </Button>
            </Stack>
            <Grid2 container spacing="32px" justifyContent={isOverviewBlogLoading ? 'space-between' : undefined}>
                {isOverviewBlogLoading
                    ? Array.from({ length: isMdOrAbove ? ITEMS_PER_PAGE_MD : ITEMS_PER_PAGE_SM }).map((_, index) => (
                          <Grid2 key={`blog-skeleton-${index}`} size={{ xs: 12, md: 3 }}>
                              <MediaStoryCard
                                  key={`blog-skeleton-${index}`}
                                  image={{
                                      url: '/static/img/backgrounds/LeftSplitImageDesktop1.png',
                                      alt_text: intl.formatMessage({
                                          id: 'blog.loadingThumbnail',
                                          defaultMessage: 'Loading blog thumbnail',
                                      }),
                                  }}
                                  baseUrl=""
                                  date="Loading"
                                  slug="123"
                                  title="Loading"
                                  loading
                              />
                          </Grid2>
                      ))
                    : latestBlogItems?.map((blog) => (
                          <Grid2
                              key={blog.id}
                              size={{
                                  xs: 12,
                                  md: 3,
                              }}
                          >
                              <MediaStoryCard
                                  key={blog.id}
                                  baseUrl="/app/blog/"
                                  slug={blog.slug}
                                  image={{
                                      url: blog.image?.url ?? '',
                                      alt_text: blog.image?.alt_text ?? '',
                                  }}
                                  date={blog.date}
                                  title={blog.title}
                                  link={{
                                      url: '/app/blog/' + blog.slug,
                                  }}
                              />
                          </Grid2>
                      ))}
            </Grid2>
        </Box>
    ) : null;
};
